import { InAppReview } from '@capacitor-community/in-app-review'
import { DashboardResponse } from './api/dashboard'

const THREE_WEEKS_MS = 21 * 24 * 60 * 60 * 1000
const LAST_REVIEW_KEY = 'lastReviewRequest'

/**
 * Requests an app review if the user has both income and expenses.
 * Platform rate-limiting is handled automatically by iOS and Android:
 * - iOS: Max 3 times per 365 days
 * - Android: Time-bound quota (~1 month)
 *
 * Additional 3-week cooldown prevents excessive API calls.
 *
 * @param dashboard - Dashboard data containing bruto income and expenses
 */
export const requestInAppReview = async (dashboard?: DashboardResponse) => {
  if (!dashboard) return

  const lastReviewStr = localStorage.getItem(LAST_REVIEW_KEY)
  const lastReviewRequest = lastReviewStr ? parseInt(lastReviewStr) : null

  const now = Date.now()

  if (lastReviewRequest && now - lastReviewRequest < THREE_WEEKS_MS) {
    return
  }

  try {
    const hasExpenses = dashboard.expenses > 0
    const hasSignificantIncome = dashboard.bruto > 5000

    if (hasExpenses && hasSignificantIncome) {
      await InAppReview.requestReview()
      localStorage.setItem(LAST_REVIEW_KEY, now.toString())
    }
  } catch (error) {
    console.debug('Review request failed:', error)
  }
}
